// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"608":"46bdef7d","920":"46bdef7d","948":"18218877"}[chunkId] + ".chunk.css";
};